<body>
  <div class="grid-overlay">
    <app-page-header></app-page-header>

    <div class="form-container">
      <div class="breadcrumb">
        <button type="button" (click)="goBack()">{{ 'onboardingUsersRoles.roleForm.breadcrumbRoot' | translate }}</button>
        <span>/ {{ 'onboardingUsersRoles.roleForm.createBreadcrumb' | translate }}</span>
      </div>

      <h1>{{ 'onboardingUsersRoles.roleForm.createTitle' | translate }}</h1>
      <p class="subtitle">{{ 'onboardingUsersRoles.roleForm.createSubtitle' | translate }}</p>

      <form [formGroup]="roleForm" (ngSubmit)="save()">
        <div class="role-basics">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'onboardingUsersRoles.roleForm.name' | translate }}</mat-label>
            <input matInput formControlName="name" maxlength="45" required>
            @if (roleForm.get('name')?.hasError('required')) {
              <mat-error>{{ 'onboardingUsersRoles.roleForm.nameRequired' | translate }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'onboardingUsersRoles.roleForm.description' | translate }}</mat-label>
            <input matInput formControlName="description" maxlength="200">
          </mat-form-field>
        </div>

        <div class="preview-box">
          <strong>{{ 'onboardingUsersRoles.roleForm.summaryTitle' | translate }}</strong>
          @if (selectedPermissions.length > 0) {
            <div class="preview-content">
              <p>{{ compactPreviewText }}</p>
              @if (compactModulesText) {
                <p>
                  {{ 'onboardingUsersRoles.roleForm.includesPermissionsIn' | translate }} <span>{{ compactModulesText }}</span>.
                </p>
              }
            </div>
          } @else {
            <p>{{ 'onboardingUsersRoles.roleForm.emptyPreview' | translate }}</p>
          }
        </div>

        <div class="perms-layout">
          <section class="panel catalog-panel">
            <div class="panel-header">
              <h2>{{ 'onboardingUsersRoles.roleForm.permissionsCatalog' | translate }}</h2>
              <span>{{ 'onboardingUsersRoles.roleForm.selectedOfTotal' | translate:{ selected: selectedPermissions.length, total: totalPermissions } }}</span>
            </div>

            <mat-form-field appearance="fill" class="panel-search">
              <mat-label>{{ 'onboardingUsersRoles.roleForm.searchPermission' | translate }}</mat-label>
              <input matInput (input)="filterPermissions($event.target['value'])">
              <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>

            <div class="module-list">
              @for (module of modules; track module) {
                <div class="module">
                  <div class="module-header">
                    <button class="module-toggle" type="button" (click)="toggleModule(module)">
                      <mat-icon [class.open]="module.expanded">chevron_right</mat-icon>
                      <strong>{{ module.name }}</strong>
                      <span>({{ selectedCount(module) }}/{{ module.permissions.length }})</span>
                    </button>
                    <button class="module-action" type="button" (click)="toggleModuleSelection(module, $event)">
                      {{ (selectedCount(module) === module.permissions.length ? 'onboardingUsersRoles.roleForm.unselectAll' : 'onboardingUsersRoles.roleForm.selectAll') | translate }}
                    </button>
                  </div>
                  @if (module.expanded) {
                    <div class="module-body">
                      @for (permission of visiblePermissions(module); track permission) {
                        <label class="perm-row">
                          <mat-checkbox [(ngModel)]="permission.selected" [ngModelOptions]="{standalone: true}"></mat-checkbox>
                          <div>
                            <div class="perm-desc">
                              {{ permission.description }}
                              @if (permission.sensitive) {
                                <span class="sensitive" [class.high]="permission.sensitive === 'high'">!</span>
                              }
                            </div>
                          </div>
                        </label>
                      }
                      @if (visiblePermissions(module).length === 0) {
                        <p class="empty-module">{{ 'onboardingUsersRoles.roleForm.noMatches' | translate }}</p>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </section>

          <section class="panel selected-panel">
            <div class="panel-header">
              <h2>{{ 'onboardingUsersRoles.roleForm.rolePermissions' | translate }}</h2>
              <span class="active">{{ 'onboardingUsersRoles.roleForm.selectedCount' | translate:{ count: selectedPermissions.length } }}</span>
            </div>

            @if (selectedByModule.length > 0) {
              <div class="selected-list">
                @for (group of selectedByModule; track group) {
                  <div class="selected-group">
                    <h3>{{ group.name }}</h3>
                    @for (permission of group.permissions; track permission) {
                      <div class="selected-chip">
                        <div>
                          <span>{{ permission.description }}</span>
                        </div>
                        <button type="button" class="remove-permission-btn" (mousedown)="removePermission(permission, $event)" (click)="$event.preventDefault(); $event.stopPropagation()" [title]="'onboardingUsersRoles.roleForm.remove' | translate">
                          x
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            } @else {
              <div class="selected-empty">
                {{ 'onboardingUsersRoles.roleForm.noSelectedPermissions' | translate }}
              </div>
            }

          </section>
        </div>

        <div class="form-actions">
          <div class="note">{{ 'onboardingUsersRoles.roleForm.applyNote' | translate }}</div>
          <div>
            <button type="button" mat-raised-button (click)="goBack()" class="cancel-btn">{{ 'onboardingUsersRoles.buttons.cancel' | translate }}</button>
            <button type="submit" mat-raised-button color="primary" [disabled]="roleForm.invalid || !canSaveRole()">
              {{ 'onboardingUsersRoles.buttons.saveRole' | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</body>
